import { useCallback, useEffect, useState } from "react";
import useMutationObserver from "@rooks/use-mutation-observer";
var useElementSize = function (ref, config) {
    if (config === void 0) { config = { mutationObserver: true }; }
    var _a = useState(0), height = _a[0], setHeight = _a[1];
    var _b = useState(0), width = _b[0], setWidth = _b[1];
    var updateDimension = useCallback(function () {
        var element = ref.current;
        if (!element)
            return;
        setWidth(element.clientWidth);
        setHeight(element.clientHeight);
    }, [ref]);
    useMutationObserver(ref, function () {
        if (!config.mutationObserver)
            return;
        updateDimension();
    }, { subtree: true, childList: true });
    useEffect(function () {
        updateDimension();
        var resizeCallback = function () {
            updateDimension();
        };
        window.addEventListener("resize", resizeCallback);
        return function () { return window.removeEventListener("resize", resizeCallback); };
    }, [updateDimension]);
    return { height: height, width: width };
};
export default useElementSize;
//# sourceMappingURL=useElementSize.js.map